import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cn from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as updateConfigurationActions from "../../../actions/updateConfigurationActions";
import { isMonumentTombale } from "../../../services/utils.service";
import * as _ from "lodash";
import { OptionPanel } from "../components/OptionPanel";
import { isConfigRequested } from "../../../services/configurationWarningChecks"
import { TranslationContext } from "../../../context/TranslationContext";
import { CustomPartsModal } from "./customPartsModal";
import MediaQuery from "react-responsive/src";
import { gtmPro } from '../../../services/gtmPro';

class BaseHeightOptionPanelComponent extends Component {
  static contextType = TranslationContext;
  state = {openpopup: false}
  static propTypes = {
    baseHeight: PropTypes.string.isRequired,
    baseHeights: PropTypes.array.isRequired
  };

  onSelectItem = baseHeight => {
    this.props.actions.updateBaseHeight(baseHeight);
  };

  handleBaseHeightClick = () => {
        gtmPro().ctaOfConfiguration(
          {
            name: "extranet.config3d.config3d_monument_button_base",
            category: "configurateur",
            subcategory: "Monument",
            type: "cta",
            from: "left"
          },
          {template:"configurateur", subtemplate:"produit"},
          {},
          "partner",
          "product",
          "user",
          "page"
        );
    };
  getList = () => {
    const layout = this.props.monument.layout;
    const baseHeights = this.props.baseHeights.filter(item=>(item.configuration === layout)).map(item =>( item.baseHeight));
    return baseHeights;
  };
  getCurrentBH = (list) => {
    if (list.some(item=> item === this.props.baseHeight)){
      return this.props.baseHeight
    }
    else if (list.length>0){
      // Ce truc est super important car dès le début on met à jour la configuraiton avec le premier élèment de la liste
      // we deactivate this line and handle it in CONFIG_UPDATE_LAYOUT reducer instead
      // this.props.actions.updateBaseHeight(list[0]);
      return list[0]
    }
    return "";

  };

  handleCloseConfirmPopup = () => {
    this.setState({ openpopup: false });
  };

  render() {
    const t = this.context;
    const baseHeightsList = this.getList();
    const currentBaseHeght = this.getCurrentBH(baseHeightsList);
    const isConfigDeformable = this.props.configDeformable && (this.props.configDeformable?.layout || this.props.configDeformable?.baseHeight);
    const disabled = !(baseHeightsList.length && baseHeightsList[0] !== "0") || isConfigRequested()
    const displayValue =  isConfigDeformable ? t("config3d_custom_pieces_modal_title") : this.props.baseHeight
    return (
      <>
      {!this.props.hideDisplay &&  <OptionPanel
        closeOnClickInside={true}
        className="BaseHeightOptionPanel"
        id="BaseHeightOptionPanel"
        buttonContent={
          isMonumentTombale(this.props.monument) ? "Épaisseur" : t("config3d_monument_button_base") || "Soubassem."
        }
        buttonIcon="base-height-icon"
        buttonClassName={`btn-config-secondary text-dark config-button-background ${!disabled && 'config-button-hover'} `}
        showValue = {displayValue}
        onClick={this.handleBaseHeightClick}
        disabled={disabled}
      >
        {baseHeightsList.map(baseHeight => (
          <button
            key={baseHeight}
            onClick={() => this.onSelectItem(baseHeight)}
            className={cn("OptionPanelSquareItem secondary3-hover", {
              active:
                parseInt(currentBaseHeght, 10) === parseInt(baseHeight, 10) && !this.props.configDeformable.baseHeight // == pour matcher string et number
            })}
          >
            {baseHeight}
          </button>
        ))}
        {(this.props.deformable || isConfigDeformable) && 
            <button
              onClick={()=>this.setState({openpopup: true})}
              className={cn("OptionPanelSquareItem secondary3-hover custom",{
                active: this.props.configDeformable.baseHeight
              })}
            >
              <span className="edit-icon icon icon-large text-dark-icon"></span>
              <MediaQuery minWidth={658}>
                {t("config3d_custom_pieces_modal_title")}
              </MediaQuery>

            </button>
          }
      </OptionPanel>
      }
      <CustomPartsModal openpopup={this.state.openpopup}
                      baseHeightCustom={true}
                      onCloseConfirmPopup ={this.handleCloseConfirmPopup}
                      toggleSteps={this.props.toggleSteps}
                      launchIntro={this.props.launchIntro}
                      modalName={this.props.modalName}
                     >
      </CustomPartsModal>
      
      </>
    );
  }
}

export const BaseHeightOptionPanel = connect(
  (state, ownProps) => ({
    deformable: _.get(state, "configurator.current.configuration.monument.deformable"),
    monument: _.get(state, "configurator.current.configuration.monument"),
    baseHeight: _.get(
      state,
      "configurator.current.configuration.monument.base.height"
    ),
    baseHeights: state.configurator.current.options.layoutsBaseHeights,
    configDeformable: state.configurator.current.configuration.deformable,
  }),
  dispatch => ({
    actions: bindActionCreators(updateConfigurationActions, dispatch)
  })
)(BaseHeightOptionPanelComponent);
